import { createContext, useEffect, useState } from 'react';

const BookkeepingQuestionsProgressContext = createContext();

export function BookkeepingQuestionsProgressContextProvider(props) {

  const [currentPage, setCurrentPage] = useState(28);
  const [currentQ, setCurrentQ] = useState(0);


  function updateCurrentPageHandler(page) {
    setCurrentPage(page);
  }

  const context = {
    currentPage: currentPage,
    currentQ: currentQ,
    updateCurrentPage: updateCurrentPageHandler,
  };

  return <BookkeepingQuestionsProgressContext.Provider value={context}>
    {props.children}
  </BookkeepingQuestionsProgressContext.Provider>
}

export default BookkeepingQuestionsProgressContext;
